/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSkillsDelete } from "../../funcs/llmSkillsDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteSkillRequest$inboundSchema,
};

export const tool$llmSkillsDelete: ToolDefinition<typeof args> = {
  name: "llm-skills-delete",
  description: `Delete skill

Delete a skill and all its versions.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSkillsDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
